/* ============================================================
   METAL FINGERS - SELECTION DRAWER CONFIG

   The one place to change what the drawer offers and teaches.
   Nothing below is duplicated anywhere else in the theme.
   ============================================================ */

window.MFNeedleConfig = {

  /* Configurations Metal Fingers does not carry.

     These are excluded before any option is built, so they never
     appear as a choice, crossed out or otherwise. This is different
     from being out of stock: an out-of-stock configuration IS part of
     the range and is shown crossed out so the artist knows it exists.

     1225CM currently shows Shopify inventory. It is still excluded
     here on purpose: it is not part of the range we present. */
  notCarried: ['MF-CM-1007-C', 'MF-CM-1225-C'],

  /* Redesign product pages, reached through the safe ?view= route so
     no template suffix has to be set on the live products. */
  pdpView: {
    'tight-round-liner-1': 'trl',
    'round-liner': 'rl',
    'traditional-round-liner': 'trd',
    'round-shader': 'rs',
    'curvy-magnum': 'cm',
    'str8-magnum': 'm1'
  },

  /* Gauge education. relative is the needle diameter in millimetres,
     used to size the circles; mm is what the customer reads. Gauges
     are always written as two digits, and the diameter has no dash
     between the two parts. */
  gaugeReference: [
    { label: '06', mm: '.20mm', relative: 0.20 },
    { label: '08', mm: '.25mm', relative: 0.25 },
    { label: '10', mm: '.30mm', relative: 0.30 },
    { label: '12', mm: '.35mm', relative: 0.35 }
  ],

  /* Taper education. length is the real taper length in millimetres
     and drives the drawing directly: the narrowing section of each
     needle is drawn in proportion to it, on a shaft of fixed overall
     length, so M, L and XL can be compared at a glance. */
  taperReference: [
    { key: 'M', mm: '3.5mm', length: 3.5 },
    { key: 'L', mm: '5.5mm', length: 5.5 },
    { key: 'XL', mm: '7mm', length: 7.0 }
  ],

  /* The OG Collection is clearance. In the selector it takes the
     place of the link to the full product page: there is nothing to
     sell on an old page for a range that is not coming back, and the
     reason is more use to the artist than the link was.

     The handles themselves are NOT repeated here. They live once, in
     mf-cart-config.js, and the cart's own OG note is drawn from the
     same list, so the two cannot drift apart. */
  clearanceNote: "Priced to clear. When they're gone, they're gone.",

  /* Shown for cartridges only. Wording matches the product pages. */
  cartridgeUnit: '20 sterile cartridges per box',
  proof: [
    'Precision Japanese Nippon 304H stainless steel',
    'Medical-grade polycarbonate housing',
    'Ethylene oxide gas sterilised'
  ]
};
